module.exports = __webpack_public_path__ + "assets/img/hotel-img-nodata.b254bbf8.svg";